const PositionElementGuidLines = ({ guidlineData }) => {
  if (!guidlineData) return null;

  const styles = {
    vertical: {
      position: "absolute",
      top: 0,
      width: "1px",
      height: "100%",
      backgroundColor: "blue"
    },
    horizontal: {
      position: "absolute",
      left: 0,
      width: "100%",
      height: "1px",
      backgroundColor: "red"
    }
  };

  return (
    <>
      <div style={{ ...styles.vertical, left: guidlineData.left }}></div>
      <div style={{ ...styles.vertical, left: guidlineData.right }}></div>
      <div style={{ ...styles.horizontal, top: guidlineData.top }}></div>
      <div style={{ ...styles.horizontal, top: guidlineData.bottom }}></div>
    </>
  );
};
export default PositionElementGuidLines;
